"use client";

import type { FC } from "react";
import type { GameFragment } from "../../types";
import LinkComponent from "./LinkComponent";

type Props = {
  game: GameFragment;
  isBridgeSite: boolean;
};

const ProviderLinkComponent: FC<Props> = ({ game, isBridgeSite }) => {
  // Safety clause
  if (!game) return null;

  const provider = game.menuItem?.[0];
  if (!provider?.handle) return null;
  const href = isBridgeSite
    ? `/casino/providers/${provider.handle}`
    : `/providers/${provider.handle}`;
  return (
    <LinkComponent href={href} className="relative pointer-events-auto">
      <p className="text-center font-dm-sans text-[9px] font-semibold leading-3 text-white">
        {provider.name ?? " "}
      </p>
    </LinkComponent>
  );
};

export default ProviderLinkComponent;
